import config from '../config';
import store from '../store';

import Task from './task';
import Api from 'smartdoors-shared/js/helpers/api';
import { generateQueryString } from 'smartdoors-shared/js/helpers/uri';

export default Object.assign(Api, {
    fetch(method, path, params = null, ...args) {
        return new Task('api', { method, path, params, args });
    },

    getUrl(path, params = null) {
        path = process.env.VUE_APP_PORTAL_URL + config.api.baseUrl + '/' + path;

        if(params) {
            path += (path.indexOf('?') != -1 ? '&' : '?') + generateQueryString(params);
        }

        return path;
    },

    getHeaders(headers = {}) {
        if(!('Accept' in headers)) {
            headers.Accept = 'application/json';
        }

        if(!('Authorization' in headers) && store.getters['user/loggedIn']) {
            headers.Authorization = 'Bearer ' + store.state.user.accessToken
        }
        
        return headers;
    },

    getTaskExecutor(fetchArgs) {
        return (resolve, reject) => {
            return this.resolveFetch(fetchArgs, resolve, reject);
        };
    }
});